export default __webpack_public_path__ + "static/media/teladoc-icon.db640780.svg";